<template>
  <div class="video universal">
    <h1 class="page-title">视频课 · {{tabs == 1?date_content.total:date_content.list.length||0}}</h1>
    <TabList v-model="tabs" />
    <None v-if="tabShow" moreFind :moreURL="moreURL" moreText="发现更多课程" />
    <div v-else>
      <VideoContentItem
        v-for="(item,index) in tabs == 1?date_content.videoCourseList:date_content.list"
        :key="item.id"
        :dateObject="item"
        :tabs="tabs"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
      />
    </div>

    <DevPagination
      v-show="pageShow"
      class="margin-top-66"
      :total="date_content.total"
      :pageSize="10"
      :change="change"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import TabList from "@/components/Course/TabList.vue";
import VideoContentItem from "@/components/Course/VideoContentItem.vue";
import None from "@/components/Base/None.vue";
import {
  getSubscribeCourseList,
  getVideoCourseList,
  getSubscribeVIPCourseList,
} from "@/utils/api";

export default {
  components: {
    DevPagination,
    TabList,
    VideoContentItem,
    None,
  },
  data() {
    return {
      date_content: {
        list: [],
        videoCourseList: [],
      },
      tabs: 1,
      pageShow: false,
      tabShow: false,
      change: false,
      size: 0,
      pageInfo: "",
    };
  },
  computed: {
    moreURL() {
      if (this.tabs == 0) {
        return "https://download.csdn.net/list/course/2-0-0-0-1-1.html";
      } else if (this.tabs == 1) {
        return "https://download.csdn.net/list/course/1-0-0-0-1-1.html";
      } else if (this.tabs == 2) {
        return "https://download.csdn.net/list/course/4-0-0-0-1-1.html";
      } else {
        return "";
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    // 初始化函数
    init() {
      this.date_content = {
        list: [],
        videoCourseList: [],
      };
    },
    postDate(page) {
      this.pageInfo = page;

      this.$store.dispatch("changeLoading", true);
      switch (this.tabs) {
        case 0:
          this.getSubscribeCourse();
          break;
        case 1:
          this.getPayCourse();
          break;
        case 2:
          this.getVIPCourse();
          break;
      }
    },
    // 获取 免费课 数据
    getSubscribeCourse() {
      getSubscribeCourseList().then((response) => {
        this.date_content = response.data;
        this.pageShow = false;
        this.$store.dispatch("changeLoading", false);
        this.tabChange();
      });
    },
    // 获取 付费课程 数据
    getPayCourse() {
      getVideoCourseList({
        page: this.pageInfo.current,
        pageSize: this.pageInfo.pageSize,
      })
        .then((response) => {
          this.date_content = response.data;
          this.pageShow = true;
          this.$store.dispatch("changeLoading", false);
          this.tabChange();
        })
        .catch(() => {
          // 502 刷新停止，展示空信息
          this.init();
          this.pageShow = true;
          this.$store.dispatch("changeLoading", false);
          this.tabChange();
        });
    },
    // 获取 VIP课 数据
    getVIPCourse() {
      getSubscribeVIPCourseList().then((response) => {
        this.date_content = response.data;
        this.pageShow = false;
        this.$store.dispatch("changeLoading", false);
        this.tabChange();
      });
    },
    tabChange() {
      if (this.tabs == 1) {
        this.tabShow =
          this.date_content.videoCourseList.length == 0 ? true : false;
      } else {
        this.tabShow = this.date_content.list.length == 0 ? true : false;
      }
    },
  },
  watch: {
    tabs() {
      this.change = !this.change;
      this.init();
    },
  },
};
</script>

<style lang="less" scoped>
.video {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
